import { isProduction } from "@/Environment";
import { calculateConversionValueFromShipmentFrequency } from "@/Helpers/calculateConversionValueFromShipmentFrequency";

export function useGoogleAdsConversions() {
  // Fire conversion event with dynamic value based on shipper type
  function fireConversion(
    tag: string,
    shipmentFrequency: string | undefined,
    email: string,
    phoneNumber: string,
  ) {
    if (!isProduction()) {
      return;
    }

    try {
      // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      gtag("set", "user_data", {
        email: email,
        phone_number: phoneNumber,
      });

      // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      gtag("event", "conversion", {
        send_to: tag,
        value: calculateConversionValueFromShipmentFrequency(shipmentFrequency),
        currency: "CAD",
      });
    } catch (e) {
      console.warn("Error in google tag", { e });
    }
  }

  // Secondary conversion: Account Created (for funnel visibility)
  // Tag ID: AW-478855751/Ok1RCNmAyuIbEMeEq-QB
  function onAccountCreated(
    shipmentFrequency: string | undefined,
    email: string,
    phoneNumber: string,
  ) {
    fireConversion(
      "AW-478855751/Ok1RCNmAyuIbEMeEq-QB",
      shipmentFrequency,
      email,
      phoneNumber,
    );
  }

  // Primary conversion: First Booking (what Google optimizes toward)
  // Tag ID: AW-478855751/MXhFCKyp1uIbEMeEq-QB
  // Value is now computed by the backend and passed directly
  function onFirstBookingWithValue(value: number) {
    if (!isProduction()) {
      return;
    }

    try {
      // oxlint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      gtag("event", "conversion", {
        send_to: "AW-478855751/MXhFCKyp1uIbEMeEq-QB",
        value: value,
        currency: "CAD",
      });
    } catch (e) {
      console.warn("Error in google tag", { e });
    }
  }

  return {
    onAccountCreated,
    onFirstBookingWithValue,
  };
}
